export const stage5Fields = {
    ROUTES: "routes",
    TOTAL_QUANTITY_NAME: "totalQuantity",
    TOTAL_QUANTITY_PLACEHOLDER: "Total Weight Of Crops Produced (Dry) (kg)",
    CHECK_BOX_LABEL: "Check this box if transportation is via air.",
    END_MARKET_FIELD: "",
    END_MARKET_LABEL: "End market location",
    QUANTITY_FIELD: "",
    QUANTITY_LABEL: "Quantity Of Crop Sent To This Location (kg)",
    IS_TRANSPORT_BY_AIR: "isTransportedByAir",
    LOCATION_FIELD: "addressLabel",
    QUANTITY: "quantity",
    TOTAL_QUANTITY: "totalQuantity",
    SOCKET_EVENT: "agriculture-commodity-emission-data",
    LIVE_STOCK_SOCKET_EVENT: "livestock-commodity-emission-data",
    COMMODITY_DISTRIBUTION_STAGE: 5,
    LIVE_STOCK_QUANTITY_LABEL: "Quantity shipped to this location (kg)",
    LIVE_STOCK_TOTAL_QUANTITY_PLACEHOLDER: "Quantity shipped (kg)",
}